// extracted by mini-css-extract-plugin
export default {"controlRow":"MGInput_controlRow__Df9jK","leftIcon":"MGInput_leftIcon__D+7KG","rightIcon":"MGInput_rightIcon__12vVv","rightIconButton":"MGInput_rightIconButton__uUTgA"};